import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { formatCurrencyValue } from '@utils';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    borderRadius: '8px',
    backgroundColor: (theme) => theme.palette.blues.lightestBlue,
    color: (theme) => theme.palette.blues.primaryBlue500,
    marginTop: '16px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1,
    color: 'inherit',
  },
  amount: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1,
    color: 'inherit',
  },
};

export const TotalInitialCosts = ({ products: productsProp }) => {
  const { control } = useFormContext() || {};
  const watchedProducts = useWatch({
    control,
    name: 'products',
    disabled: !control || productsProp !== undefined,
  });
  const products = productsProp ?? watchedProducts;

  const total = useMemo(
    () =>
      (products || []).reduce((sum, product) => {
        if (!product?.display) return sum;
        const netPrice = Number(product?.finalPrice?.number) || 0;
        const vat = product?.vat || 0;
        const vatDecimal = vat.toString().includes('.')
          ? Number(vat)
          : Number(vat) / 100;
        return sum + netPrice * (1 + vatDecimal);
      }, 0),
    [products]
  );

  if (!products?.some((product) => product?.display)) return null;

  return (
    <Box sx={styles.container}>
      <Box sx={styles.label}>Total Initial Costs</Box>
      <Box sx={styles.amount}>{formatCurrencyValue({ number: total })}</Box>
    </Box>
  );
};

export default TotalInitialCosts;
